import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2f09ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "senior-setup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign-tip" }, [
  /*#__PURE__*/_createTextVNode(" 如果此处设置为 "),
  /*#__PURE__*/_createElementVNode("b", null, "需要签字"),
  /*#__PURE__*/_createTextVNode("，则所有审批人“同意时” "),
  /*#__PURE__*/_createElementVNode("b", null, "必须签字")
], -1))

export function render(_ctx, _cache) {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "80px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "审批同意时是否签字" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              "inactive-text": "无需签字",
              "active-text": "需要签字",
              modelValue: _ctx.setup.sign,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.setup.sign) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}